import { CashAccount } from "./cash-account";
import { CashTransferDetail } from "./cash-transfer-detail";
import { JournalEntry } from "./journal-entry";
import { PaymentMethod } from "./payment-method";
import { SystemField } from "./system-field";

export class CashTransfer extends SystemField{ 
     ref_num?:string;
     transfer_date?:string;
     is_void?:number;
     transfer_type?:string;
     from_cash_acc_id?:string;
     to_cash_acc_id?:string;
     transfer_amount?:number;
     description?:string;
     status?:string;
     charge_amount?:number;
     total_amount?:number;
     transaction_ref_num?:string;
     from_pay_method_id?:string;
     to_pay_method_id?:string;
     note?:string; 
     recordtype_name?:string;
     recordtype_id?:string;

     //formula fields
     fin_period?:string;

     //relationship
     general_ledger?:JournalEntry;
     to_cash_account?:CashAccount;
     from_cash_account?:CashAccount;
     form_payment_method?:PaymentMethod;
     to_payment_method?:PaymentMethod;
     cash_transfer_details?:CashTransferDetail[];
     receipts?:CashTransferDetail[];
     desbursements?:CashTransferDetail[];
     
}
